import { Link } from "react-router-dom";
import pageBannerImg from '../../assets/images/page-banner-img.png'
import ServiceSection from '../services_section/servicessection'

function ServicesSection() {
    return (
        <>
            <div className="page-banner-area pt-100">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="single-page-banner-content">
                                <h1>Our Services</h1>
                                <ul>
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>
                                        Our Services
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="single-page-banner-img" >
                                <img src={pageBannerImg} alt="images" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="services-page-area pt-50 pb-100">
                <div className="container">
                    <div className="row">
                        <ServiceSection search={true} />
                    </div>
                    <div className="pagination-area">
                        <a href="#" className="prev page-numbers" >
                            <i className='bx bx-arrow-back' ></i>
                        </a>
                        <span className="page-numbers current" aria-current="page" >
                            01
                        </span>
                        <a href="#" className="page-numbers" >02</a>
                        <a href="#" className="page-numbers" >03</a>
                        <a href="#" className="prev page-numbers" >
                            <i className='bx bx-arrow-back arrow-back-tow' ></i>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ServicesSection